export const WEBLATE_COMPONENT_NAME = 'common/taxonomy-i18n';
